import React from 'react';
import HeroSection from '../components/HeroSection';
import ServiceSection from '../components/ServiceSection';
import FounderSection from '../components/FounderSection';
import ImageUploadSection from '../components/ImageUploadSection';
import ContactSection from '../components/ContactSection';
import EventGallery from '../components/EventGallery';
import LICSlideshow from '../components/LICSlideshow';
import GalleryPage from '../gallery_component/GalleryPage';
import Gallery from '../gallery_component/Gallery';
import VideoSection from './VideoSection';
import ImageGallery from './ImageGallery';
// import Slideshow from '../components/Slideshow';

const HomePage: React.FC = () => {
  return (
    <>
      <HeroSection 
        title="जीवन आधार - तुमच्या भविष्याची खात्रीशीर सुरक्षा"
        subtitle="उत्तम उद्यासाठी सर्वसमावेशक विमा योजना, आर्थिक सेवा आणि समुदायाला आधार"
        buttonText="अधिक जाणून घ्या"
        buttonLink="#services"
      />
      

{/* <Slideshow/> */}
{/* <Gallery/> */}

{/* <LICSlideshow /> */}
{/* <EventGallery /> */}

      <ServiceSection />
      <FounderSection />
      <ImageGallery/>
      <VideoSection/>
      {/* <GalleryPage/> */}
      {/* <ImageUploadSection /> */}
      <ContactSection />
    </>
  );
};

export default HomePage;
